export default class HeaderMenuGroup {
  $items = null;
  $selectedItem = null;
  CLASSNAME_ITEM = 'l-header__nav__category';
  CLASSNAME_TOGGLE = 'l-header__nav__category__toggle';
  CLASSNAME_SELECTED = '--selected';

  constructor($items) {
    this.$items = [...$items];

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onToggleKeyDown = this.onToggleKeyDown.bind(this);

    this.$items.forEach(($item) => {
      const $toggle = $item.querySelector('.' + this.CLASSNAME_TOGGLE);
      $toggle.setAttribute('tabindex', 0);
      $toggle.addEventListener('click', this.onToggleClick);
      $toggle.addEventListener('keydown', this.onToggleKeyDown);
    });
  }

  toggle($target) {
    if (this.$selectedItem === $target) {
      this.unselect();
    } else {
      this.select($target);
    }
  }

  select($target) {
    this.$items.forEach(($item) => {
      if ($target === $item) {
        $item.classList.add(this.CLASSNAME_SELECTED);
        this.$selectedItem = $item;
      } else {
        $item.classList.remove(this.CLASSNAME_SELECTED);
      }
    });
  }

  unselect() {
    this.$items.forEach(($item) => {
      $item.classList.remove(this.CLASSNAME_SELECTED);
    });
    this.$selectedItem = null;
  }

  getItemFromEventTarget($eventTarget) {
    let $el = $eventTarget;
    while ($el && $el.classList) {
      if ($el.classList.contains(this.CLASSNAME_ITEM)) {
        return $el;
      }
      $el = $el.parentElement;
    };
  }

  onToggleClick(e) {
    e.preventDefault();
    const $item = this.getItemFromEventTarget(e.target);
    this.toggle($item);
  }

  onToggleKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      const $item = this.getItemFromEventTarget(e.target);
      this.toggle($item);
    }
  }
}
